// extracted by mini-css-extract-plugin
export default {"video":"VideoSkip_video__8qi8d"};